'use client';
/** @jsxImportSource @emotion/react */

import { forwardRef } from 'react';

import MuiMenu, { type MenuProps as MuiMenuProps } from '@mui/material/Menu';

type ExcludedMuiProps =
  | 'autoFocus'
  /**
   * Omitting the component prop from Menu ensures that its behavior, accessibility, and positioning remain consistent,
   * as Menu relies heavily on specific underlying elements to function correctly.
   * This prevents potential rendering or interaction issues caused by replacing the base element with incompatible components.
   */
  | 'component'
  | 'disableAutoFocusItem'
  | 'transitionDuration'
  | 'transitionProps';

/**
 * @deprecated Please use `Menu` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-menu-migration--menu-migration-guide Migration guide}
 */
export type MenuProps = Omit<MuiMenuProps, ExcludedMuiProps>;

/**
 * @deprecated Please use `Menu` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-menu-migration--menu-migration-guide Migration guide}
 */
export const Menu = forwardRef<HTMLDivElement, MenuProps>((props, ref) => {
  return (
    <MuiMenu
      {...props}
      ref={ref}
      MenuListProps={{
        ...props.MenuListProps,
        disabledItemsFocusable: true,
      }}
    />
  );
});

Menu.displayName = 'Menu';
